/**
 * Facilities Service – real API only.
 */

import { serviceLogger } from '../utils/serviceLogger';
import { normalizeServiceError } from '../utils/serviceError';
import * as realImpl from './real/facilitiesService.real';

const wrap = (fnName) => async (...args) => {
  try {
    return await realImpl[fnName](...args);
  } catch (error) {
    serviceLogger.error(`[${fnName}] Error:`, error);
    throw normalizeServiceError(error);
  }
};

export const getFacilities = wrap('getFacilities');
export const createFacility = wrap('createFacility');
export const updateFacility = wrap('updateFacility');
export const deleteFacility = wrap('deleteFacility');
export const duplicateFacility = wrap('duplicateFacility');
export const getFacilitiesByOrganization = wrap('getFacilitiesByOrganization');
export const getFacilitiesPaginated = wrap('getFacilitiesPaginated');
export const updateFacilitiesBulk = wrap('updateFacilitiesBulk');
export const getAllFacilities = wrap('getAllFacilities');
export const getFacilitiesV3Paginated = wrap('getFacilitiesV3Paginated');
export const getDataUnitsByFacility = wrap('getDataUnitsByFacility');
export const associateDeviceIdentifier = wrap('associateDeviceIdentifier');
export const disassociateDeviceIdentifier = wrap('disassociateDeviceIdentifier');
